const TIPOS_FASES_CONFIGURACION = [
  {
    id: 1,
    name: 'Cliente creado en EdasNEO',
  },
  {
    id: 2,
    name: 'Nueva contraseña creada',
  },
  {
    id: 3,
    name: 'Configuración iniciada',
  },
  {
    id: 4,
    name: 'Descarga automática configurada',
  },
  {
    id: 5,
    name: 'Certificados y empresas configurados',
  },
  {
    id: 6,
    name: 'Tutorial completado',
  },
  {
    id: 7,
    name: 'Configuración finalizada',
  },
  {
    id: 8,
    name: 'Acabado manualmente',
  },
]

export {
  TIPOS_FASES_CONFIGURACION
}
